<template>
    <div>
        <UserNavigation/>
        <h1>O nama</h1>
    </div>
</template>

<script>
import UserNavigation from '../UserNavigation'

export default {
    name: 'About',
    components: {
        UserNavigation
    }
}
</script>

<style scoped>
* {
    background: #F0EAD6;
}

</style>